export default __webpack_public_path__ + "static/brcc-full-width-1-7d6067dc1e70fa43bafe5b19ab3e2711.avif";